module.exports = __webpack_public_path__ + "img/erp_logo.34df1e02.png";